import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import form_data from "./formData";

const NeiZhangFeiYongApi = createApi({
    reducerPath: 'NeiZhangFeiYongApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/x/nzf'        
    }),
    tagTypes:['feiyongType','feiyong','feiyongSH'],
    endpoints(build) {
        return {            
            //新建费用类型
            feiyongTypeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyongType'],
            }),         
            //修改保存费用类型
            feiyongTypeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyongType'],
            }),         
            //删除费用类型
            feiyongTypeDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongTypeDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyongType'],
            }),         
            //查询费用类型
            feiyongTypeList: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongTypeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyongType'],
            }),         
            //修改费用类型
            feiyongTypeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyongType'],
            }),          
            //新建费用
            feiyongAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),         
            //修改保存费用
            feiyongUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),         
            //删除费用
            feiyongDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),         
            //审核费用
            feiyongSH: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongSH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),         
            //取消审核费用
            feiyongDelSH: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongDelSH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),         
                  
            //查询费用
            feiyongList: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),         
                  
            //查询费用审核
            getfeiyongSH: build.query({
                query(user) {                    
                    return {
                        url: '/getfeiyongSH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),         
            //修改费用
            feiyongUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),          
            //年度费用统计
            feiyongYearTJ: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongYearTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),          
            //年度费用类型统计
            feiyongYearTypeTJ: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongYearTypeTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),          
            //月度费用统计
            feiyongMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),          
            //月度费用类型统计
            feiyongMonthTypeTJ: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongMonthTypeTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),          
            //未加入利润表数据
            getNotFeiYongLiRunDan: build.query({
                query(user) {                    
                    return {
                        url: '/getNotFeiYongLiRunDan',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),          
        }
    }
})

export const { 
    useFeiyongTypeAddMutation,
    useFeiyongTypeListQuery,
    useFeiyongTypeUpdateQuery,
    useFeiyongTypeUpdateSaveMutation,
    useFeiyongTypeDelMutation,
    useFeiyongAddMutation,
    useFeiyongListQuery,
    useFeiyongUpdateQuery,
    useFeiyongUpdateSaveMutation,
    useFeiyongDelMutation,
    useFeiyongSHMutation,
    useGetfeiyongSHQuery,
    useFeiyongDelSHMutation,
    useFeiyongYearTJQuery,
    useFeiyongMonthTJQuery,
    useFeiyongMonthTypeTJQuery,
    useFeiyongYearTypeTJQuery,
    useGetNotFeiYongLiRunDanQuery,
} = NeiZhangFeiYongApi;
export default NeiZhangFeiYongApi;